export const EVENT_NAMES = {
  CAPTURE_VIEW: 'capture.view',
  CAPTURE_CTA_CLICK: 'capture.cta.click',
  CAPTURE_CTA_EXPOSED: 'capture.cta.exposed',
  CAPTURE_PLAY: 'capture.play',
  CAPTURE_PROGRESS_25: 'capture.progress.25',
  CAPTURE_PROGRESS_50: 'capture.progress.50',
  CAPTURE_PROGRESS_75: 'capture.progress.75',
  CAPTURE_COMPLETE: 'capture.complete',
  ARTIST_PROFILE_VIEW: 'artist.profile.view',
} as const;

export type PublicEventName = (typeof EVENT_NAMES)[keyof typeof EVENT_NAMES];
